
export const BASE_URL_CHARGING_SESSION = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/charging-session";
export const BASE_URL_CHARGING_SESSION_ADMIN = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/admin/charging-session";